import { useContext } from "react";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { updateBackgroundLoadingState } from "store/store";
import { useGlobalData } from "hooks/useGlobalData";
import NavContext from "components/molecules/Navigation/components/common/NavContext";
import BackgroundLoader from "../BackgroundLoader/BackgroundLoader";

/**
 * A container component which is used to wrap the page content (everything to the right of the menu).
 * Handles various responsiveness related issues and also applies the shrink class when the left menu is opened.
 */

const Main = function ({ banners, children, isFullscreen }) {
  const { navigationConfig } = useContext(NavContext);
  const [timezoneBannerShown, isLoggedInAs] = banners;
  const { state } = useStateMachine({ updateBackgroundLoadingState });
  useGlobalData();

  const paddingBottom =
    !timezoneBannerShown && !isLoggedInAs ? 40 : (timezoneBannerShown ? 48 : 0) + (isLoggedInAs ? 48 : 0);

  return (
    <main
      style={{ paddingBottom, transition: "0.15s ease-out" }}
      className={`${isFullscreen ? "main-fullscreen" : ""} ${navigationConfig.expanded && !isFullscreen && "shrink"}`}
    >
      <BackgroundLoader show={state.showBackgroundLoader} />
      {children}
    </main>
  );
};

Main.propTypes = {
  children: PropTypes.node.isRequired,
  banners: PropTypes.instanceOf(Array).isRequired,
  isFullscreen: PropTypes.bool.isRequired,
};

export default Main;
